import { intl } from "LocaleWrapper";
import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { costTypeSelectOptionSchema } from "view/costtypes/utils/costType.schema";
import { relationSelectOptionSchema } from "view/relations/utils/relation.schema";
import { vatCodeSelectOptionSchema } from "view/vatcodes/utils/vatCode.schema";

export const invoiceLineSchema = (hasAgreement: boolean) => z.object({
	id: z.number().nullable(),
	price: z.object({
		currency: ZodSchema.requiredField(z.object({
			isoCode: z.string().nullable().optional(),
			rate: z.number().nullable().optional(),
			symbol: z.string().nullable().optional(),
		})),
		value: ZodSchema.requiredField(z.number()),
	}),
	quantity: ZodSchema.requiredField(z.number()),
	costType: costTypeSelectOptionSchema.nullable(),
	vatCode: ZodSchema.requiredField(vatCodeSelectOptionSchema),
	description: z.string().max(255),
	unexpected: z.boolean(),
	invoiceReference: z.string().max(255),
	creditor: relationSelectOptionSchema.nullable(),
}).superRefine((data, ctx) => {
	if (!hasAgreement && !data.costType) {
		ctx.addIssue({
			code: "custom",
			message: intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" }),
			path: [ "costType" ],
		});
	}
});

export type InvoiceLineSchemaInput = z.input<ReturnType<typeof invoiceLineSchema>>;
export type InvoiceLineSchemaOutput = z.output<ReturnType<typeof invoiceLineSchema>>;

export const approveInvoiceLineSchema = z.object({
	reference: z.string().min(1).max(255),
});

export type ApproveInvoiceLineSchemaInput = z.input<typeof approveInvoiceLineSchema>;
export type ApproveInvoiceLineSchemaOutput = z.output<typeof approveInvoiceLineSchema>;
